export var SelectedItemOperationValue;
(function (SelectedItemOperationValue) {
    SelectedItemOperationValue["DELETE"] = "delete";
    SelectedItemOperationValue["RENAME"] = "rename";
})(SelectedItemOperationValue || (SelectedItemOperationValue = {}));
